
import {View} from 'backbone';
import template from 'dashboard/connections/details/connection-forms.ejs';
import ConnectionResearchView from 'dashboard/connections/details/ConnectionResearchView';

class ConnectionForms extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'change input[name=_url],input[name=_username],input[name=_password],input[name=_timeout],input[name=_datasourceName],input[name=_databaseName]': 'processConnectionInputs',
            'change input[name=_useProxy]': 'processConnectionCheckboxes',
            'click input[name=selectForm]': 'selectForm'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    processConnectionCheckboxes(){
        return this.connectionService.processConnectionCheckboxes.apply(this.connectionService, arguments);
    }

    processConnectionInputs(){
        return this.connectionService.processConnectionInputs.apply(this.connectionService, arguments);
    }

    selectForm(){
        return this.connectionService.selectForm.apply(this.connectionService, arguments);
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const connectionResearchView = new ConnectionResearchView({el:'#connectionResearch', model:this.model });
        connectionResearchView.render();

        this.delegateEvents();
        return this;
    }

}

export default ConnectionForms;